// src/store/slices/lpnSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface LpnState {
  lpnData: any;
  // ... other state properties
}

const initialState: LpnState = {
  lpnData: {},
  // ... other initial state
};

const lpnSlice = createSlice({
  name: 'lpn',
  initialState,
  reducers: {
    setLpnData: (state, action: PayloadAction<any>) => {
      state.lpnData = action.payload;
    },
    // ... other reducers
  }
});

export const { setLpnData } = lpnSlice.actions;
export default lpnSlice.reducer;